















































































































































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import BasicHelperMixin from '@/components/helpers/basic-helper-mixin';

import CreateCampaignDialogFlowLanding from '@/views/reports/forms/campaign/components/create-campaign-dialog-flow-landing.vue';
import CreateCampaignDialogFlowOffer from '@/views/reports/forms/campaign/components/create-campaign-dialog-flow-offer.vue';
import FlowPathMixin from '@/views/reports/mixins/flow/flow-path-mixin';


@Component({
  components:{
    CreateCampaignDialogFlowLanding,
    CreateCampaignDialogFlowOffer
  }
})
export default class PathCard extends mixins(BasicHelperMixin, FlowPathMixin) {
  @Prop(String)
  type: string;

  @Prop()
  path: any;
 
  @Prop()
  form: string;

  @Prop()
  errorsRaw: any[];

  @Prop()
  pathError: boolean;

  @Prop()
  allWorkspaceIds: any[];

  @Prop()
  offerOptions: Offer[];

  @Prop()
  landingOptions: Landing[];

  virtualScrollBreakpoint: number = 100;

  addOfferEvent: string = 'flow-new-offer';
  editOfferEvent: string = 'flow-edit-offer';
  deleteOfferEvent: string = 'flow-delete-offer';
  addLandingEvent: string = 'flow-new-landing';
  editLandingEvent: string = 'flow-edit-landing';
  deleteLandingEvent: string = 'flow-delete-landing';

  get selections() {
    return this.type === 'landings'
      ? this.path.landings
      : this.path.offers;
  }

  get isAddDisabled() {
    return this.offersCount > 1 && this.type === 'offers';
  }

  redirectMode: string = '302';
  retargeting: boolean = false;
  doubleMeta: boolean = false;
  no_direct: boolean = true;

  retargetingValue: any = '';
  redirectDomainId: any = '';

  get typeSingle(){
    // единственное число
    return this.type.substring(0, this.type.length - 1);
  }

  @Watch('retargetingValue')
  onRetargetingValueChanged(value: any, oldValue: any) {
    if (this.type === 'landings') {
      this.path.retargetingLandings = value;
    } else{
      this.path.retargetingOffers = value;
    }
  }

  @Watch('redirectDomainId')
  onRedirectDomainIdChanged(value: any, oldValue: any) {
    if (this.type === 'landings') {
      this.path.redirectDomainId  = value;
    } else{
      this.path.redirectDomainIdOffers = value;
    }
  }

  @Watch('redirectMode')
  onRedirectModeChanged(value: any, oldValue: any) {
    if (this.type === 'landings') {
      this.path.redirectMode = value;
    } else{
      this.path.redirectModeOffers = value;
    }
  }

  @Watch('no_direct')
  onNoDirectChanged(value: any, oldValue: any) {
    if (this.type === 'landings') {
      this.path.directLinking = !value;
    }
  }

  mounted() {
    if (this.type === 'landings') {

      this.no_direct = !this.path.directLinking;
      this.redirectMode = this.path.redirectMode || '302';
      this.retargetingValue = this.path.retargetingLandings;
      this.redirectDomainId = this.path.redirectDomainId;
    } else {
      this.redirectMode = this.path.redirectModeOffers || '302';
      this.retargetingValue = this.path.retargetingOffers;
      this.redirectDomainId = this.path.redirectDomainIdOffers;
    }

    this.retargeting = !!this.retargetingValue;
  }

  add_item() {
    if(this.type === 'landings') {
      this.addLanding();
    } else {
      this.addOffer();
    }
  }

  create_item() {
    if(this.type === 'landings') {
      this.addNewLanding();
    } else {
      this.addNewOffer();
    }
  }

  get pathCardTitle() {
    switch (this.type){
      case 'landings': return this.t('landings');
      case 'offers': return this.t('offers');
    }
  } 

  get itemActions() {
    return {
      add: {
        key: 'add',
        title: this.typeSingle === 'landing' ? this.t('Add Landing') : this.t('Add Offer'),
        disabled: this.isAddDisabled || !this.no_direct,
        click: () => this.add_item()
      },
      addNew: {
        key: 'addNew',
        title: this.typeSingle === 'landing' ? this.t('Add new landing') : this.t('Add new offer'),
        disabled: !this.no_direct,
        click: () => this.create_item()
      }
    }
  }

  get addMenuList() {
    return [
      this.itemActions.add,
      this.itemActions.addNew
    ];
  }
  
  get retargetingLabel() {
    switch(this.type){
      case 'landings': return this.t('Use retargeting for landings');
      case 'offers': return this.t('Use retargeting for offers');
    }
  }
  
  get showPlanLimitsWarning_doubleMeta() {
    return this.redirectMode==='doubleMeta' && this.hasPlanLimitsRestriction('doubleMetaRedirect')
  }
}
